import { api, storePath } from "./api";

export type Asset = {
  id: string; kind: string; filename: string; content_type: string; size: number; alt: string; status: string;
  url?: string; dominant_color?: string; variants: { width: number; format: string; url: string }[]; created_at: string;
};
type Ticket = { upload_id: string; url: string; method: string; headers: Record<string, string> };

// uploadFile runs the presigned flow: ticket -> PUT straight to storage -> complete (specs 24).
export async function uploadFile(storeId: string, file: File, purpose: string, onProgress?: (p: number) => void): Promise<Asset> {
  const ticket = await api<Ticket>(storePath(storeId, "/files/uploads"), {
    body: { filename: file.name, content_type: file.type || "application/octet-stream", size: file.size, purpose },
  });
  await new Promise<void>((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open(ticket.method || "PUT", ticket.url);
    for (const [k, v] of Object.entries(ticket.headers ?? {})) xhr.setRequestHeader(k, v);
    xhr.upload.onprogress = (e) => e.lengthComputable && onProgress?.(e.loaded / e.total);
    xhr.onload = () => (xhr.status < 300 ? resolve() : reject(new Error(`upload failed (${xhr.status})`)));
    // A network-level failure: usually the storage host doesn't resolve or its
    // certificate isn't trusted (locally: s3.sooquna.test in /etc/hosts + Caddy CA).
    xhr.onerror = () => reject(new Error(`Couldn't reach file storage at ${new URL(ticket.url).host}. Check your connection and try again.`));
    xhr.send(file);
  });
  return api<Asset>(storePath(storeId, `/files/uploads/${ticket.upload_id}/complete`), { method: "POST" });
}

export const thumbOf = (a: Pick<Asset, "variants" | "url">) =>
  a.variants?.find((v) => v.width >= 200 && v.format === "webp")?.url ?? a.variants?.[0]?.url ?? a.url;
